module.exports = __webpack_public_path__ + "img/ry3.6e24273a.svg";